import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import React from "react";
import { ToolTip } from "../../shared/ToolTip/ToolTip";
import { CheckBoxLabel, CheckBoxLabelWrapper, CheckBoxWrapper, CheckMark, CustomCheckBoxWrapper, InputWrapper, StyledInput, ToolTipWrapper } from "./CustomCheckBox.style";
interface HyperLink {
  text: string;
  url: string;
}
interface CheckBoxProps {
  checked: boolean;
  label?: string;
  mobileLabel?: string;
  showTooltip?: boolean;
  tooltipText?: string;
  hyperlink?: HyperLink;
}
export const CustomCheckBox: React.FC<CheckBoxProps> = t0 => {
  const $ = _c(19);
  const {
    checked,
    label,
    showTooltip,
    tooltipText,
    hyperlink
  } = t0;
  let t1;
  if ($[0] !== checked) {
    t1 = <StyledInput type="checkbox" tabIndex={-1} checked={checked} readOnly={true} />;
    $[0] = checked;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckBoxWrapper><CheckMark className="checkmark">✓</CheckMark></CheckBoxWrapper>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${label} `;
  let t4;
  if ($[3] !== hyperlink) {
    t4 = hyperlink && <Link href={hyperlink.url} target="_blank">{`${hyperlink.text} ↗`}</Link>;
    $[3] = hyperlink;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <CheckBoxLabelWrapper><CheckBoxLabel>{t3}{t4}</CheckBoxLabel></CheckBoxLabelWrapper>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t5) {
    t6 = <InputWrapper>{t1}{t2}{t5}</InputWrapper>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== showTooltip || $[12] !== tooltipText) {
    t7 = showTooltip && tooltipText && <ToolTip text={tooltipText} />;
    $[11] = showTooltip;
    $[12] = tooltipText;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <ToolTipWrapper>{t7}</ToolTipWrapper>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <CustomCheckBoxWrapper>{t6}{t8}</CustomCheckBoxWrapper>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};